"use strict";
'use es6';
/* eslint-disable react/no-multi-comp */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIconButton = _interopRequireDefault(require("UIComponents/button/UIIconButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var customRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _withPartials = _interopRequireDefault(require("../hocs/withPartials"));

var _Object$freeze;

var DEFAULT_THUMBNAIL_HEIGHT = 40;
var NAV_BUTTON_TYPES = Object.freeze((0, _keyMirror.default)({
  next: null,
  previous: null
}));
var NAV_BUTTON_ICONS = Object.freeze((_Object$freeze = {}, (0, _defineProperty2.default)(_Object$freeze, NAV_BUTTON_TYPES.next, 'right'), (0, _defineProperty2.default)(_Object$freeze, NAV_BUTTON_TYPES.previous, 'left'), _Object$freeze));

var DefaultMainComponent = function DefaultMainComponent(props) {
  return _react.default.createElement("div", props);
};

var Carousel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Carousel, _Component);

  function Carousel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Carousel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Carousel).call(this, props));
    _this.handleGoToImage = _this.handleGoToImage.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoToPreviousImage = _this.handleGoToPreviousImage.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoToNextImage = _this.handleGoToNextImage.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      imageIndex: 0
    };
    return _this;
  }

  (0, _createClass2.default)(Carousel, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var imageUrls = this.props.imageUrls;
      var nextImageUrls = nextProps.imageUrls;

      if (imageUrls.length !== nextImageUrls.length) {
        this.setState({
          imageIndex: 0
        });
      }
    }
  }, {
    key: "handleGoToImage",
    value: function handleGoToImage(imageIndex) {
      this.setState({
        imageIndex: imageIndex
      });
    }
  }, {
    key: "handleGoToPreviousImage",
    value: function handleGoToPreviousImage() {
      var imageUrls = this.props.imageUrls;
      var imageIndex = this.state.imageIndex;
      this.handleGoToImage(imageIndex === 0 ? imageUrls.length - 1 : imageIndex - 1);
    }
  }, {
    key: "handleGoToNextImage",
    value: function handleGoToNextImage() {
      var imageUrls = this.props.imageUrls;
      var imageIndex = this.state.imageIndex;
      var lastImageIndex = imageUrls.length - 1;
      this.handleGoToImage(imageIndex === lastImageIndex ? 0 : imageIndex + 1);
    }
  }, {
    key: "renderNavButton",
    value: function renderNavButton(buttonType, onClick) {
      return _react.default.createElement(_UIIconButton.default, {
        key: buttonType + "-nav-button",
        className: "carousel__nav-btn",
        onClick: onClick,
        use: "unstyled"
      }, _react.default.createElement(_UIIcon.default, {
        name: NAV_BUTTON_ICONS[buttonType]
      }));
    }
  }, {
    key: "renderPreviousButton",
    value: function renderPreviousButton(hasMultipleImages) {
      if (!hasMultipleImages) {
        return null;
      }

      return this.renderNavButton(NAV_BUTTON_TYPES.previous, this.handleGoToPreviousImage);
    }
  }, {
    key: "renderNextButton",
    value: function renderNextButton(hasMultipleImages) {
      if (!hasMultipleImages) {
        return null;
      }

      return this.renderNavButton(NAV_BUTTON_TYPES.next, this.handleGoToNextImage);
    }
  }, {
    key: "renderThumbnails",
    value: function renderThumbnails() {
      var _this2 = this;

      var _this$props = this.props,
          imageUrls = _this$props.imageUrls,
          partial = _this$props.partial,
          thumbnailHeight = _this$props.thumbnailHeight;
      var imageIndex = this.state.imageIndex;
      return imageUrls.map(function (imageUrl, index) {
        var thumbnailClasses = (0, _classnames.default)('carousel__thumbnail-btn', {
          'is--focused': index === imageIndex
        });
        return _react.default.createElement(_UIButton.default, {
          key: "carousel-thumbnail-" + index,
          className: thumbnailClasses,
          onClick: partial(_this2.handleGoToImage, index),
          use: "transparent"
        }, _react.default.createElement(_UIImage.default, {
          height: thumbnailHeight,
          responsive: false,
          src: imageUrl,
          shape: "thumbnail"
        }));
      });
    }
  }, {
    key: "renderThumbnailsContainer",
    value: function renderThumbnailsContainer(hasMultipleImages) {
      if (!hasMultipleImages) {
        return null;
      }

      return _react.default.createElement(_UIFlex.default, {
        align: "center",
        className: "carousel__thumbnails-container",
        direction: "row",
        justify: "center"
      }, this.renderThumbnails());
    }
  }, {
    key: "renderImageContainer",
    value: function renderImageContainer(imageListStyles) {
      var renderedImages = this.props.imageUrls.map(function (url, index) {
        return _react.default.createElement(_UIImage.default, {
          key: index,
          responsive: true,
          src: url
        });
      });
      return _react.default.createElement("div", {
        key: "image-container",
        className: "carousel__image-container"
      }, _react.default.createElement(_UIList.default, {
        childClassName: "carousel__image-list__item",
        className: "carousel__image-list",
        style: imageListStyles
      }, renderedImages));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          imageUrls = _this$props2.imageUrls,
          MainComponent = _this$props2.mainComponent;
      var totalImages = imageUrls.length;
      var lastImageIndex = totalImages - 1;
      var hasMultipleImages = totalImages > 1;
      var imageIndex = this.state.imageIndex;

      if (imageIndex > lastImageIndex) {
        imageIndex = lastImageIndex;
      }

      var imageListStyles = {
        width: 100 * totalImages + "%",
        transform: "translateX(" + -1 * imageIndex * (100 / totalImages) + "%)"
      };
      var renderedMainComponent = customRenderer.render(MainComponent, {
        className: 'carousel__main-container',
        children: [this.renderPreviousButton(hasMultipleImages), this.renderImageContainer(imageListStyles), this.renderNextButton(hasMultipleImages)]
      });
      var renderedThumbnails = this.renderThumbnailsContainer(hasMultipleImages);
      return _react.default.createElement(_UIFlex.default, {
        align: "stretch",
        className: "carousel",
        direction: "column"
      }, renderedMainComponent, renderedThumbnails);
    }
  }]);
  return Carousel;
}(_react.Component);

Carousel.propTypes = {
  imageUrls: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  mainComponent: customRenderer.propType.isRequired,
  partial: _propTypes.default.func.isRequired,
  thumbnailHeight: _propTypes.default.number.isRequired
};
Carousel.defaultProps = {
  mainComponent: DefaultMainComponent,
  thumbnailHeight: DEFAULT_THUMBNAIL_HEIGHT
};

var _default = (0, _withPartials.default)(Carousel);

exports.default = _default;
module.exports = exports.default;